import { Navigate, useRoutes } from "react-router-dom";


import { protectedRoutes } from "./protected";
import { publicRoutes } from "./public";
import { useUser } from "lib/auth";
import { Spin } from "antd";
const NotFound=()=><div>404 NOT FOUND</div>
const LandingCompment=()=>{
 const user= useUser();
 if(user.isLoading){
  return <Spin/>
 }
 else if(user.data){
  return <Navigate to='app'/>

 }else{
  return <Navigate to='auth/login'/>

 }
}


export const AppRoutes = () => {
  const user=useUser().data;
  const commonRoutes = [{path: "*", element: <NotFound/>}];
  const routes =user ? protectedRoutes : publicRoutes;
    const element = useRoutes([...routes, ...commonRoutes]);
  return <>{element}</>;
};
